import React from 'react';
import { useDashboardProfileStats } from '../hooks/use-dashboard-profile-stats.js';
import { useDashboardRecentRecords } from '../hooks/use-dashboard-recent-records.js';
import DashboardPageView from './dashboard-page-view.jsx';

function DashboardPageContainer() {
  const { cards, isLoading, error } = useDashboardProfileStats();
  const { recentSections, isRecentLoading, recentError } = useDashboardRecentRecords();
  const dashboardError = [error, recentError].filter(Boolean).join('\n');

  return (
    <DashboardPageView
      isLoading={isLoading}
      error={dashboardError}
      cards={cards}
      recentSections={recentSections}
      isRecentLoading={isRecentLoading}
    />
  );
}

export default DashboardPageContainer;
